export default __webpack_public_path__ + "static/media/profile-arbiar.f01f470a.png";